module.exports = __webpack_public_path__ + "static/media/closed-captioning.5a2d7b9d.svg";